// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/TrademarkCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var TrademarkCircleOutlined = function TrademarkCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleOutlinedSvg
  }));
};

TrademarkCircleOutlined.displayName = 'TrademarkCircleOutlined';
export default React.forwardRef(TrademarkCircleOutlined);